import { Link } from 'react-router-dom';

const comparisonRows = [
  { standard: 'Универсальная программа', ours: 'Предварительная диагностика', oursDesc: 'Изучаем компанию, KPI, воронку и реальные диалоги менеджеров до старта.' },
  { standard: 'Теория и лекции', ours: 'Практика на кейсах компании', oursDesc: '80% времени — упражнения, разбор звонков и реальных ситуаций из вашего бизнеса.' },
  { standard: 'Один день обучения', ours: 'Внедрение изменений', oursDesc: 'Обучение не заканчивается в день тренинга — мы сопровождаем внедрение.' },
  { standard: 'Без поддержки после', ours: 'Посттренинговое сопровождение', oursDesc: 'Домашние задания, разбор кейсов, контрольные встречи и обратная связь.' },
  { standard: 'Красивые презентации', ours: 'Измеримые бизнес-результаты', oursDesc: 'Конверсия, средний чек, повторные продажи — метрики, которые растут.' },
];

export default function WhyMostTrainingsFail() {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="py-20 md:py-28 bg-white">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-4">
          Почему большинство корпоративных тренингов не дают результата
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center mb-12 max-w-3xl mx-auto">
          Стандартный подход к <Link to="/enciklopediya-korporativnogo-obucheniya/obuchenie-otdela-prodazh" className="text-teal-600 hover:text-teal-700 underline">обучению отдела продаж</Link> часто сводится к однодневному мероприятию, которое быстро забывается. Мой подход построен иначе.
        </p>

        <div className="overflow-hidden rounded-2xl border border-gray-200">
          {/* Header */}
          <div className="grid grid-cols-2 bg-gray-100">
            <div className="px-5 py-4 font-bold text-gray-500 text-sm">Стандартный тренинг</div>
            <div className="px-5 py-4 font-bold text-teal-700 text-sm bg-teal-50">Наш подход</div>
          </div>

          {/* Rows */}
          {comparisonRows.map((row, i) => (
            <div key={i} className={`grid grid-cols-2 ${i % 2 === 0 ? 'bg-white' : 'bg-gray-50/50'}`}>
              <div className="px-5 py-3 md:py-4 text-gray-600 text-sm flex items-start gap-2">
                <i className="ri-close-circle-line text-red-400 mt-0.5 flex-shrink-0"></i>
                <span>{row.standard}</span>
              </div>
              <div className="px-5 py-3 md:py-4 bg-teal-50/40">
                <div className="flex items-start gap-2">
                  <i className="ri-checkbox-circle-line text-teal-600 mt-0.5 flex-shrink-0"></i>
                  <div>
                    <div className="font-semibold text-teal-800 text-sm mb-0.5">{row.ours}</div>
                    <p className="text-gray-600 text-xs leading-relaxed">{row.oursDesc}</p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-10">
          <button
            onClick={() => scrollTo('contact')}
            className="bg-teal-600 text-white px-8 py-4 rounded-lg text-base font-semibold hover:bg-teal-700 transition-all transform hover:scale-105 whitespace-nowrap cursor-pointer inline-flex items-center gap-2"
          >
            Хочу обучение, которое работает
            <i className="ri-arrow-right-line"></i>
          </button>
        </div>
      </div>
    </section>
  );
}